import { useLocation, useNavigate, useParams } from "react-router-dom";
import { ROUTES } from "../../../helpers/constants";
import { AiFillCaretRight } from 'react-icons/ai';
import { Toaster } from "react-hot-toast";

import { FolderInfo } from "../../components/folder-info/folder-info";
import FolderContentComponent from "./components/folder-content";
import TableSection from "./components/table-section";
import CreateClientModal from "../clients/components/create-modal";
import { useEffect, useState } from "react";
import ClientAPI from "../../../services/api/clients.api";
import { useRecoilValue } from "recoil";
import { userAtom } from "../../../services/atoms/auth.atoms";

const ClientsDetails = () => {
  let { state } = useLocation();
  const { id: paramId } = useParams();

  let navigate = useNavigate();
  const goToClientsList = () => navigate(ROUTES.CLIENTS.route);
  const [open, setOpen] = useState(false);
  const [details, setDetails] = useState()
  const user = useRecoilValue(userAtom)

  const handleOpenModal = () => setOpen(!open);

  const getDetailClient = async(id)=>{
    const clientDetail = await ClientAPI.findClient(id)
    clientDetail && setDetails(clientDetail.data)

  }

  const clientId = state?.client?.id || paramId;

  useEffect(()=>{
    if (!state?.client && clientId) {
      ClientAPI.findClient(clientId).then((res) => {
        if (res?.data) {
          setDetails(res.data);
          navigate(window.location.pathname, { replace: true, state: { client: res.data } });
        }
      });
    } else if (clientId) {
      getDetailClient(clientId)
    }
  }, [open, clientId])

  return (
    <div className="gm-clients-details-container">
      <Toaster />
      {state?.client &&
        <CreateClientModal
          open={open}
          toggle={handleOpenModal}
          isCreate={false}
          dataEdit={state?.client}
          getDetailClient={getDetailClient}
        />
      }
      {user?.data.isSuperAdmin && (
      <div className="gm-cd-top-navigation">
        <div className="gm-cd-top-info">
          <button className="gm-cd-back" type="button" onClick={goToClientsList}>
            Lista Clientes
          </button>
          {state?.client?.name && (
            <>
              <AiFillCaretRight />
              <div className="gm-cd-company-info">{`${state?.client?.name}: ${
                state?.client?.sector || "No Informada"
              }`}</div>
            </>
          )}
        </div>
        <div className="gm-actions-dropdown">
            <button
              type="button"
              className="gm-primary-button gm-banner-button"
              onClick={handleOpenModal}
            >
              Editar
            </button>
        </div>
      </div>
            )}
      {(details || state?.client) && (
        <FolderInfo
          title={
            (details || state?.client)?.name
              ? `${(details || state?.client)?.name} • ${
                  (details || state?.client)?.sector || "No Informada"
                }`
              : ""
          }
          ContentComponent={<FolderContentComponent client={details || state?.client} />}
        />
      )}
      {state?.client &&
        <TableSection navigate={navigate} client={state?.client || null} onTestSent={() => getDetailClient(state.client.id)} />
      }
    </div>
  );
}

export default ClientsDetails;